import { render, staticRenderFns } from "./dingMoblieImport.vue?vue&type=template&id=9ffee614&scoped=true&"
import script from "./dingMoblieImport.vue?vue&type=script&lang=js&"
export * from "./dingMoblieImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffee614",
  null
  
)

export default component.exports